type TErrorMessages = {
  [route: string]: {
    [error: number]: string;
  };
};

export default {
  '/developer/platform/manager/public/sign-in': {
    401: 'Usuário ou senha inválidos',
  },
  '/developer/bloomberg/secondary-market/pins': {
    500: 'Ocorreu um erro, tente novamente',
    504: 'A área de pesquisa excede o limite máximo. Selecione uma área menor, ou refine sua pesquisa.',
    513: 'A área de pesquisa excede o limite máximo. Selecione uma área menor, ou refine sua pesquisa.',
    413: 'A área de pesquisa excede o limite máximo. Selecione uma área menor, ou refine sua pesquisa.',
  },
  '/developer/bloomberg/secondary-market/big-numbers': {
    500: 'Ocorreu um erro, tente novamente',
    504: 'A área de pesquisa excede o limite máximo. Selecione uma área menor, ou refine sua pesquisa.',
    513: 'A área de pesquisa excede o limite máximo. Selecione uma área menor, ou refine sua pesquisa.',
    413: 'A área de pesquisa excede o limite máximo. Selecione uma área menor, ou refine sua pesquisa.',
  },
  '/developer/platform/family-income/family-income': {
    500: 'Não foi possível carregar os dados de Renda familiar média.',
    504: 'Não foi possível carregar os dados de Renda familiar média.',
  },
} as TErrorMessages;
